import React from 'react';
import { useState, useEffect } from 'react';
import { updatePasswordApi } from '@/app/csr-src/apis/profile/accountSetting.api';

import { pwdBtnStyle } from '@/app/csr-src/pages/profile/personalCenter/personalAccountSetDialog/components/style';
import style from './style.module.scss';
import LoadingIcon from '@/components/loadingIcon';
import CheckPsd from '@/assets/icons/CheckPsd.svg';
import NoCheckPsd from '@/assets/icons/NoCheckPsd.svg';
import {
  Button,
  InputLabel,
  IconButton,
  FormControl,
  InputAdornment,
  OutlinedInput,
} from '@mui/material';
import UKToast from '@/components/UKToast/index';
import Password from '@/components/user/password/password';
import { useTranslation } from '@/i18n/client';
import { passwordStyle } from '../style';

interface PropsType {
  jumpToDialog: (v: { type: string; flag?: string; successText?: string }) => void; // 跳转到修改密码对话框
}
const ChangePassword = ({ jumpToDialog }: PropsType) => {
  const [oldPassword, setOldPassword] = useState(''); // 旧密码输入的内容
  const [newPassword, setNewPassword] = useState(''); // 新密码输入的内容

  const [isLoading, setIsLoading] = useState(false); // 是否加载中
  const [psdDisabled, setPsdDisabled] = useState(true); // 按钮禁用
  const [showOldPassword, setShowOldPassword] = useState(false); // 是否查看旧密码输入内容

  useEffect(() => {
    if (oldPassword && newPassword) {
      setPsdDisabled(false);
    } else {
      setPsdDisabled(true);
    }
  }, [oldPassword, newPassword]);

  // 点击 Submit 按钮；修改密码
  const psdSignInSubmit = async () => {
    try {
      setIsLoading(true);
      const [err, res]: any = await updatePasswordApi({
        oldPassword: oldPassword,
        newPassword: newPassword,
      });
      if (res && res.success) {
        jumpToDialog({
          type: 'passwordSuccess',
          flag: 'Change Password',
          successText: t('login.common.addPwdSuccess'),
        });
      } else {
        UKToast.show({
          icon: 'error',
          content: res.msg,
          duration: 2000,
        });
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.log('error: ', error);
    }
  };
  const { t } = useTranslation();

  return (
    <div className={style.changePassword}>
      {/* 老密码 */}
      <FormControl
        fullWidth
        sx={{
          margin: '10px 0',
          ...passwordStyle,
        }}
        variant='outlined'
        color='info'
      >
        <InputLabel htmlFor='standard-adornment-amount'>{t('login.common.oldPwd')}</InputLabel>
        <OutlinedInput
          id='outlined-adornment-password'
          autoComplete='old-password'
          label={t('login.common.oldPwd')}
          value={oldPassword}
          onChange={(event: any) => setOldPassword(event.target.value)}
          type={showOldPassword ? 'password' : 'text'}
          endAdornment={
            <InputAdornment position='end'>
              <IconButton
                onClick={() => setShowOldPassword((show) => !show)}
                onMouseDown={(event: React.MouseEvent<HTMLButtonElement>) => event.preventDefault()}
                onMouseUp={(event: React.MouseEvent<HTMLButtonElement>) => event.preventDefault()}
              >
                {showOldPassword ? <NoCheckPsd /> : <CheckPsd />}
              </IconButton>
            </InputAdornment>
          }
        />
      </FormControl>
      {/* 新密码 */}
      <div className={style.password}>
        <Password setPsdVal={setNewPassword} psdValidatedHandle={setPsdDisabled} />
      </div>

      <Button
        variant='contained'
        disabled={psdDisabled || isLoading}
        startIcon={isLoading && <LoadingIcon />}
        onClick={psdSignInSubmit}
        sx={{ ...pwdBtnStyle }}
      >
        {t('login.common.submit')}
      </Button>
    </div>
  );
};

export default ChangePassword;
